/**
 * Wallet Pass Service
 * Issues and serves Apple Wallet and Google Wallet loyalty passes for Convercus programs. Internal administrators register programs, mint program API keys, maintain store locations, configure wallet design and levels, read adoption analytics and query the audit trail; customer-facing clients download a pass through the program-scoped download routes, and the wallets themselves keep it current through the Apple PassKit web service and the Google Wallet Objects callback. Every path below already carries the gateway base prefix `/wallet-pass-service`.
 *
 * The version of the OpenAPI document: 1.0.39938
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DesignPreviewAnnotationTargetDto } from './design-preview-annotation-target-dto';


export interface DesignPreviewAnnotationDto { 
    /**
     * Stable id for FE binding
     */
    id: string;
    /**
     * Where to show this annotation: preview tooltips, Pass customizations card, and/or Design form hints
     */
    surfaces: Array<DesignPreviewAnnotationDto.SurfacesEnum>;
    target: DesignPreviewAnnotationTargetDto;
    label: string;
    value?: string;
    /**
     * Data origin: walletDesign, accountBalance, statusLevel, accountCustomProperties, passMetadata, program, scannableConfig, platformPolicy, …
     */
    source: string;
    sourceLabel: string;
    /**
     * Already localized tooltip for admin UI
     */
    tooltip: string;
    /**
     * Design form control name when surfaces includes form
     */
    formControl?: object | null;
    /**
     * Platform scope for preview tooltips; default both
     */
    platformScope?: DesignPreviewAnnotationDto.PlatformScopeEnum;
}
export namespace DesignPreviewAnnotationDto {
    export type SurfacesEnum = 'preview' | 'customizations' | 'form';
    export const SurfacesEnum = {
        Preview: 'preview' as SurfacesEnum,
        Customizations: 'customizations' as SurfacesEnum,
        Form: 'form' as SurfacesEnum
    };
    export type PlatformScopeEnum = 'ios' | 'android' | 'both';
    export const PlatformScopeEnum = {
        Ios: 'ios' as PlatformScopeEnum,
        Android: 'android' as PlatformScopeEnum,
        Both: 'both' as PlatformScopeEnum
    };
}


